export default __webpack_public_path__ + "static/media/36I-114298_-20845_0.761a3164.jpg";